// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3N5vU","info":"PatientInfo_info__3z_5X"};